import { Recipe } from '../types/recipe';
import { recipeContextManager } from './recipeContextService';
import {
  AssistantResponse,
  DietaryAnalysisResult,
  DietaryCompliance,
} from '@/types/assistantTypes';
import { handleStudioRecipeGeneration } from './recipeService';

export type { AssistantResponse, DietaryAnalysisResult, DietaryCompliance };
export { handleStudioRecipeGeneration };

// Legacy compatibility functions - now delegate to the new context manager
export function setRecipeContext(recipe: Recipe): void {
  recipeContextManager.setCurrentRecipe(recipe);
}

export function clearRecipeContext(): void {
  recipeContextManager.setCurrentRecipe(null);
}

export function getCurrentRecipeContext(): { recipe: Recipe } | null {
  const currentRecipe = recipeContextManager.getCurrentRecipe();
  return currentRecipe ? { recipe: currentRecipe } : null;
}

/**
 * Handles recipe generation from the Recipe Creation Studio.
 * Thin passthrough kept for import-compatibility; the fire-and-forget dietary
 * analysis that used to live here was removed — its result was discarded
 * (one wasted LLM call per generation). Nutrition analysis for the review
 * page runs via useDietaryAnalysis instead.
 */
export async function handleStudioRecipeGenerationWrapper(
  options: any & { model?: string }
): Promise<AssistantResponse> {
    return handleStudioRecipeGeneration(options);
}